import { HttpErrorResponse } from '@angular/common/http';
import { VorlagenType } from '@dworkflow/shared/model';
import { VorlageWriteModel } from '@dworkflow/shared/model/vorlagen/vorlage-write.model';
import { VorlageModel } from '@dworkflow/shared/model/vorlagen/vorlage.model';
import { VorlagenLadeType } from '@dworkflow/shared/model/vorlagen/vorlagen-lade-type.enum';
import { VorlagenkonfigurationModel } from '@dworkflow/shared/model/vorlagenkonfiguration.model';
import { guid } from '@dworkflow/shared/utility/guid';
import { createAction, props } from '@ngrx/store';

/**
 * Vorlagenkonfigurationen
 */

// Create
export const createVorlagenkonfiguration = createAction(
  '[Grundeinstellungen] Create Vorlagenkonfiguration',
  props<{ value: VorlagenkonfigurationModel }>()
);

export const createVorlagenkonfigurationSucceeded = createAction(
  '[Grundeinstellungen] Create Vorlagenkonfiguration succeeded',
  props<{ newValue: VorlagenkonfigurationModel }>()
);

export const createVorlagenkonfigurationFailed = createAction(
  '[Grundeinstellungen] Create Vorlagenkonfiguration failed',
  props<{ error: HttpErrorResponse }>()
);

// Delete
export const requestDeleteKonfiguration = createAction(
  '[Grundeinstellungen] Request Delete Vorlagenkonfiguration',
  props<{ id: guid; laufendeKonfigurationsId: number; titel: string }>()
);

export const deleteVorlagenkonfiguration = createAction(
  '[Grundeinstellungen] Delete Vorlagenkonfiguration',
  props<{ id: guid; laufendeKonfigurationsId: number; titel: string }>()
);

export const deleteVorlagenkonfigurationSucceeded = createAction(
  '[Grundeinstellungen] Delete Vorlagenkonfiguration succeeded',
  props<{ id: guid; laufendeKonfigurationsId: number }>()
);

export const deleteVorlagenkonfigurationFailed = createAction(
  '[Grundeinstellungen] Delete Vorlagenkonfiguration failed',
  props<{ error: HttpErrorResponse }>()
);

// Load Vorlagenkonfigurationen
export const loadVorlagenkonfigurationen = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfigurationen'
);

export const loadVorlagenkonfigurationenSucceeded = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfigurationen succeeded',
  props<{ values: VorlagenkonfigurationModel[] }>()
);

export const loadVorlagenkonfigurationenFailed = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfigurationen failed',
  props<{ error: HttpErrorResponse }>()
);

// Load Vorlagenkonfiguration
export const loadVorlagenkonfiguration = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfiguration',
  props<{ laufendeKonfigurationsId: number }>()
);

export const loadVorlagenkonfigurationSucceeded = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfiguration succeeded',
  props<{ konfiguration: VorlagenkonfigurationModel }>()
);

export const loadVorlagenkonfigurationFailed = createAction(
  '[Grundeinstellungen] Load Vorlagenkonfiguration failed',
  props<{ error: HttpErrorResponse }>()
);

// Load Anzahl sichtbarer Vorlagenkonfigurationen
export const loadAnzahlSichtbarerVorlagenkonfigurationen = createAction(
  '[Grundeinstellungen] Load Anzahl sichtbarer Vorlagenkonfigurationen'
);

export const loadAnzahlSichtbarerVorlagenkonfigurationenSucceeded = createAction(
  '[Grundeinstellungen] Load Anzahl sichtbarer Vorlagenkonfigurationen succeeded',
  props<{ anzahlSichtbarerKonfigs: number }>()
);

export const loadAnzahlSichtbarerVorlagenkonfigurationenFailed = createAction(
  '[Grundeinstellungen] Load Anzahl sichtbarer Vorlagenkonfigurationen failed',
  props<{ error: HttpErrorResponse }>()
);

/**
 * Vorlagen
 */

// Create
export const createVorlage = createAction(
  '[Grundeinstellungen] Create Vorlage',
  props<{ vorlage: VorlageWriteModel; vorlagenLadeType: VorlagenLadeType }>()
);

export const createVorlageSucceeded = createAction(
  '[Grundeinstellungen] Create Vorlage succeeded',
  props<{ newValue: VorlageModel; vorlagenLadeType: VorlagenLadeType }>()
);

export const createVorlageFailed = createAction(
  '[Grundeinstellungen] Create Vorlage failed',
  props<{ error: HttpErrorResponse }>()
);

// Update
export const updateVorlage = createAction(
  '[Grundeinstellungen] Update Vorlage',
  props<{ vorlage: VorlageWriteModel; vorlagenLadeType: VorlagenLadeType }>()
);

export const updateVorlageSucceeded = createAction(
  '[Grundeinstellungen] Update Vorlage succeeded',
  props<{ newValue: VorlageModel; vorlagenLadeType: VorlagenLadeType }>()
);

export const updateVorlageFailed = createAction(
  '[Grundeinstellungen] Update Vorlage failed',
  props<{ error: HttpErrorResponse }>()
);

// Delete
export const deleteVorlage = createAction(
  '[Grundeinstellungen] Delete Vorlage',
  props<{ vorlage: VorlageModel; vorlagenLadeType: VorlagenLadeType }>()
);

export const deleteVorlageSucceeded = createAction(
  '[Grundeinstellungen] Delete Vorlage succeeded',
  props<{ id: guid; vorlagenLadeType: VorlagenLadeType }>()
);

export const deleteVorlageFailed = createAction(
  '[Grundeinstellungen] Delete Vorlage failed',
  props<{ error: HttpErrorResponse }>()
);

// Load Vorlagen
export const loadVorlagen = createAction(
  '[Grundeinstellungen] Load Vorlagen',
  props<{ vorlagenLadeType: VorlagenLadeType }>()
);

export const loadVorlagenSucceeded = createAction(
  '[Grundeinstellungen] Load Vorlagen succeeded',
  props<{ values: VorlageModel[]; vorlagenLadeType: VorlagenLadeType }>()
);

export const loadVorlagenFailed = createAction(
  '[Grundeinstellungen] Load Vorlagen failed',
  props<{ error: HttpErrorResponse }>()
);

export const loadVorlagenZumWfAnlegen = createAction(
  '[Grundeinstellungen] Load Vorlagen zum WF anlegen',
  props<{ currentUserId: number }>()
);

export const loadVorlagenZumWfAnlegenSucceeded = createAction(
  '[Grundeinstellungen] Load Vorlagen zum WF anlegen succeeded',
  props<{ values: VorlageModel[]; currentUserId: number }>()
);

export const loadVorlagenZumWfAnlegenFailed = createAction(
  '[Grundeinstellungen] Load Vorlagen zum WF anlegen failed',
  props<{ error: HttpErrorResponse }>()
);

// Load Vorlage
export const loadResolvedVorlage = createAction(
  '[Grundeinstellungen] Load Resolved Vorlage',
  props<{ vorlagenId: guid }>()
);

export const loadResolvedVorlageSucceeded = createAction(
  '[Grundeinstellungen] Load Resolved Vorlage succeeded',
  props<{ value: VorlageModel }>()
);

export const loadResolvedVorlageFailed = createAction(
  '[Grundeinstellungen] Load Resolved Vorlage failed',
  props<{ vorlagenId: guid; error: HttpErrorResponse }>()
);

// Vorlagen freigeben
export const vorlageFreigeben = createAction(
  '[Grundeinstellungen] Vorlage Freigeben',
  props<{
    vorlagenName: string;
    vorlagenId: guid;
    principalIds: number[];
    vorlagenLadeType: VorlagenLadeType;
  }>()
);

export const vorlageFreigebenSucceeded = createAction(
  '[Grundeinstellungen] Vorlage Freigeben succeeded',
  props<{ vorlagenId: guid; principalIds: number[]; vorlagenLadeType: VorlagenLadeType }>()
);

export const vorlageFreigebenFailed = createAction(
  '[Grundeinstellungen] Vorlage Freigeben failed',
  props<{ error: HttpErrorResponse }>()
);

// Vorlage kopieren
export const vorlageKopieren = createAction(
  '[Grundeinstellungen] Vorlage Kopieren',
  props<{
    vorlagenName: string;
    vorlagenId: guid;
    kopierenNachVorlagenTyp: VorlagenType;
  }>()
);

export const vorlageKopierenSucceeded = createAction(
  '[Grundeinstellungen] Vorlage Kopieren succeeded',
  props<{ vorlage: VorlageModel }>()
);

export const vorlageKopierenFailed = createAction(
  '[Grundeinstellungen] Vorlage Kopieren failed',
  props<{ error: HttpErrorResponse }>()
);

// Texte
export const loadAlleTexte = createAction('[Engine] Load Alle Texte');

export const loadDefaultTexte = createAction('[Engine] Load Default Texte');

export const loadCombinedTexteWithoutCache = createAction(
  '[Engine] Load Combined Texte without Cache'
);

export const loadDefaultTexteSucceeded = createAction(
  '[Engine] Load Default Texte Succeeded',
  props<{ texte: string }>()
);

export const loadDefaultTexteFailed = createAction(
  '[Engine] Load Default Texte Failed',
  props<{ error: HttpErrorResponse }>()
);

export const loadCombinedTexteWithoutCacheSucceeded = createAction(
  '[Engine] Load Combined Texte without Cache Succeeded',
  props<{ texte: string }>()
);

export const loadCombinedTexteWithoutCacheFailed = createAction(
  '[Engine] Load Combined Texte without Cache Failed',
  props<{ error: HttpErrorResponse }>()
);

export const postCustomTexte = createAction(
  '[Engine] Post Custom Texte',
  props<{ texte: string }>()
);

export const postCustomTexteSucceeded = createAction(
  '[Engine] Post Custom Texte Succeeded',
  props<{ texte: string }>()
);

export const postCustomTexteFailed = createAction(
  '[Engine] Post Custom Texte Failed',
  props<{ error: HttpErrorResponse }>()
);

// Vorlagen Import

export const importVorlage = createAction(
  '[Engine] Import Vorlage',
  props<{ vorlagenFileContent: string; vorlagenLadeType: VorlagenLadeType }>()
);

export const importVorlageSucceeded = createAction(
  '[Engine] Import Vorlage Succeeded',
  props<{
    vorlage: VorlageModel;
    konfiguration: VorlagenkonfigurationModel;
    vorlagenLadeType: VorlagenLadeType;
  }>()
);

export const importVorlageFailed = createAction(
  '[Engine] Import Vorlage Failed',
  props<{ error: HttpErrorResponse }>()
);

/**
 * StartseitenBeschreibung-Actions
 */
export const updateStartseitenBeschreibung = createAction(
  '[Engine] Update StartseitenBeschreibung',
  props<{ startseitenBeschreibung: string }>()
);

export const updateStartseitenBeschreibungSucceeded = createAction(
  '[Engine] Update StartseitenBeschreibung Succeeded',
  props<{ texte: string }>()
);

export const updateStartseitenBeschreibungFailed = createAction(
  '[Engine] Update StartseitenBeschreibung Failed',
  props<{ error: HttpErrorResponse }>()
);
